<template>
 <div class="row">
      <div class="col-lg-12">
        <block-cntr :btitle="'Alarm Config for Line Profile '+profileId " style="height: 410px">

             <form class="form-horizontal" role="form"> 
                <div class="form-group">
                    <label class="col-sm-3 control-label" for="alarm">{{title.alarm}}</label>
                    <div class="col-sm-3">
                        <input type="text" class="form-control" id="alarm" v-model="alarmForm.AlarmProfileId" placeholder="Alarm Profile id(1-1024)">
                    </div>
                 </div>
                 <span class="col-sm-3"></span>
                 <span class="col-sm-3">
                <button 
                type="button"
                class="btn btn-primary"
                style="min-width: 77px; color: #fff; background-color: #008B8B; border-color: #008080"
                @click="clkApply()"
            >
                {{ "Apply" }}
                </button>
                </span>
                    
           </form> 
          
        </block-cntr>
    </div>

    <info-box ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import BlockCntr from "./../components/BlockCntr.vue"
import { get, post } from "@/utils/http.js"

export default {
    name: "profileLineAlarm",
    components: {
        BlockCntr,
    },

    props:["profileId"],

    data() {
        return {
            title:{"alarm":"Ref Alarm Profile Id:"},

            alarmForm:{
                AlarmProfileId:"",
            },
        }
    },

    created() {
        this.loadtcontInfo()
    },

    methods: {
        loadtcontInfo(){
            get("alarmProfileRef",{
                params:{
                    id:this.profileId,
                }
            })
            .then((res) => (this.alarmForm.AlarmProfileId = res.data))
            .catch((err) => {
                console.log(err)
            })
        },

        resetField()
        {
            var dbaformTmp={
                AlarmProfileId:"",
            };

            this.gemForm = dbaformTmp;
        },

        clkApply(){
            var newProfile={
                  AlarmProfileId:this.alarmForm.AlarmProfileId,
                };

            this.resetField();
        }
    }
}
</script>

<style>
.table_edit{
    position: absolute;
    top:  20%;
    left: 20%;
    z-index: 1;
    width:50%

}
</style>
